<script>
import Vue from 'vue'

export default {
  components: {},
  props: {
    details: {
      require: true,
      type: String
    }
  },
  render (h) {
    if (this.details.length > 0) {
      const com = Vue.extend({
        template: this.details /*, components: {authImg} */
      })
      return h(com)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Vdetails.vue